import React, { useState, useEffect } from 'react';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import Helper from 'src/helper/Helper';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const ProfileAddressPopup = (props) => {
  const { onlyStringPattern, addressPattern, countryCodes, addressType, siteUser, zipCodePattern, houseNumPattern } = Constants;
  const { SetStatus, data } = props;
  const [detailValidation, setDetailValidation] = useState({});
  const [stateList, setStateList] = useState([]);
  const [{ countryList }, { get_profile_account_information, get_country_list, get_state_list }, { profile_address_action }] = profileStore();
  const [, setNewShipTo] = useReduxState('', "setNewShipTo");
  const isWebUser = System.avUserInfoData.currentUser === siteUser.WEB
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [invoiceDetail, setInvoiceDetail] = useState({ addressType: data.type });
  const { translation: t } = System;
  const [__check] = useAxiosIndicatorCheck();
  const companyNamePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.apacCompanyNamePattern : Constants.japanCompanyNamePattern
  const addressLinePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.addressAsiaCheckoutPattern : Constants.addressJapanCheckoutPattern

  useEffect(() => {
    async function fetchHere() {
      await get_country_list();
    }
    if (countryList?.length <= 0) {
      fetchHere()
    }
  }, [])

  useEffect(() => {
    if (Object.keys(data.addressInfo).length > 0) {
      if ((Helper.valueIsNotNull(data.addressInfo.address)) && (Helper.valueIsNotNull(data.addressInfo.address.countryCode))) {
        async function fetchStateList() {
          if (countryCodes.includes(data.addressInfo.address.countryCode)) {
            renderStateListOnCountryChange(data.addressInfo.address.countryCode)
          }
        }
        fetchStateList()
      }
      setInvoiceDetail({ ...data.addressInfo.address, id: data.addressInfo.id, companyName: data.addressInfo.companyName, addressType: data.type, isUpdateCarrier: false })
    }

    if (System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr)) {
      renderStateListOnCountryChange(Constants.countryNames.Japan)
      setInvoiceDetail({ ...data.addressInfo.address, id: data.addressInfo.id, companyName: data.addressInfo.companyName, countryCode: Constants.countryNames.Japan, addressType: data.type, isUpdateCarrier: false })
    }
  }, [data.addressInfo])

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field];
    }
    setInvoiceDetail({ ...invoiceDetail, [field]: value });
  };

  const onSaveUser = async () => {
    let isValid = onValidateData();
    if (isValid) {
      // set temp address on request new address for the Core user
      if (data?.isFrom === Constants.systemModules.CHECKOUT && System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE)) {

        const tempAddress = {
          address: { ...invoiceDetail },
          carrier: null,
          companyName: invoiceDetail.companyName,
          default: null,
          firstName: invoiceDetail.companyName,
          id: Helper.UUID(),
          lastName: '',
          isProvisional: true
        }

        let getSessionProvisionAddress = JSON.parse(sessionStorage.getItem('provisionalShippingAddress'))
        if (!getSessionProvisionAddress) {
          getSessionProvisionAddress = []
        }
        getSessionProvisionAddress.push(tempAddress)
        sessionStorage.setItem('provisionalShippingAddress', JSON.stringify(getSessionProvisionAddress))

        setNewShipTo(tempAddress);
        SetStatus(false)
        system_alert_indicator({
          name: 'profile',
          message: t('newRequestShippingAddress'),
          type: "success"
        })

      } else {
        __set("SET_INVOICE_ADDRESS")
        const res = await profile_address_action({ ...invoiceDetail, companyName: invoiceDetail.companyName?.trim(), houseNum: invoiceDetail.houseNum?.trim(), addressLineOne: invoiceDetail.addressLineOne?.trim(), addressLineTwo: invoiceDetail.addressLineTwo?.trim(), addressLineThree: invoiceDetail.addressLineThree?.trim(), cityName: invoiceDetail.cityName?.trim(), district: invoiceDetail.district?.trim(), postalCode: invoiceDetail.postalCode?.trim(), speedBoat: System.avUserInfoData.speedBoatAbbr, isUpdateCarrier: invoiceDetail.isUpdateCarrier }, Object.keys(data?.addressInfo)?.length === 0 ? 'Add' : 'Edit')
        if (res?.isSuccessFull) {
          isWebUser && await get_profile_account_information();
          SetStatus(false)
          if (data.type === addressType.SHIP_TO) {
            system_alert_indicator({
              name: 'profile',
              message: isWebUser ? (Object.keys(data.addressInfo).length === 0 ? '<b>' + t('shippingAddress') + '</b>' + t('hasBeenAddedSuccessfully') : '<b>' + t('shippingAddress') + '</b>' + t('hasBeenUpdatedSuccessfully')) : t('newShippingAddressSubmitted'),
              type: "success"
            })
          } else {
            system_alert_indicator({
              name: 'profile',
              message: Object.keys(data.addressInfo).length === 0 ? '<b>' + t('yourInvoiceAddress') + '</b>' + t('hasBeenAddedSuccessfully') : '<b>' + t('yourInvoiceAddress') + '</b>' + t('hasBeenUpdatedSuccessfully'),
              type: "success"
            })
          }
        }
        __remove("SET_INVOICE_ADDRESS")
        Helper.scrollTop();
      }
    }
  };

  const onValidateData = () => {
    let validationModal = {};
    let isCountryCode = (Helper.valueIsNotNull(invoiceDetail.countryCode));

    Helper.valueIsNotNull(invoiceDetail.companyName) ? (!Helper.validateRegex(invoiceDetail.companyName, companyNamePattern) ? validationModal.companyName = t('companyNameEnglishValidation') : "") : validationModal.companyName = t('validCompanyNameRequired');

    if (!Helper.valueIsNotNull(invoiceDetail.postalCode) || (Helper.valueIsNotNull(invoiceDetail.postalCode) && !System.validatePostalCode(invoiceDetail.postalCode, invoiceDetail.countryCode))) {
      validationModal.postalCode = t('validZipCodeRequired');
    }

    if ((isCountryCode && countryCodes.includes(invoiceDetail.countryCode) && !Helper.valueIsNotNull(invoiceDetail.stateCode)) || (!countryCodes.includes(invoiceDetail.countryCode) && invoiceDetail?.stateCode?.length > 60)) {
      validationModal.stateCode = t('validStateProvinceRequired');
    }
    if ((Helper.valueIsNotNull(invoiceDetail.houseNum)) && (!Helper.validateRegex(invoiceDetail.houseNum, houseNumPattern))) {
      validationModal.houseNumber = t('validHouseNumber');
    }
    if ((!Helper.valueIsNotNull(invoiceDetail.addressLineOne)) || (!Helper.validateRegex(invoiceDetail.addressLineOne, addressLinePattern))) {
      validationModal.addressLineOne = t('validAddressRequired');
    }
    if ((Helper.valueIsNotNull(invoiceDetail.addressLineTwo)) && ((!Helper.validateRegex(invoiceDetail.addressLineTwo, addressLinePattern)))) {
      validationModal.addressLineTwo = t('validAddressRequired');
    }
    if ((Helper.valueIsNotNull(invoiceDetail.addressLineThree)) && ((!Helper.validateRegex(invoiceDetail.addressLineThree, addressLinePattern)))) {
      validationModal.addressLineThree = t('validAddressRequired');
    }
    if ((!Helper.valueIsNotNull(invoiceDetail.cityName)) || (!Helper.validateRegex(invoiceDetail.cityName, addressLinePattern))) {
      validationModal.cityName = t('validCityRequired');
    }
    if ((Helper.valueIsNotNull(invoiceDetail.district)) && ((!Helper.validateRegex(invoiceDetail.district, houseNumPattern)))) {
      validationModal.district = t('validDistrict');
    }

    if (!isCountryCode) {
      validationModal.countryCode = t('validCountryRequired');
    }
    setDetailValidation(validationModal);
    return Object.keys(validationModal).length === 0;
  };

  const renderStateListOnCountryChange = async (value) => {
    setStateList(await get_state_list(value))
  }

  return (
    <div className="avnet-modal modal-730">
      <div className="avnet-modal-inner">
        <button type="button" className="close" data-dismiss="modal" onClick={() => { SetStatus(false) }}>×</button>
        <div className="modal-header justify-content-center">
          <h1 className="pcn-modal-heading"> {data?.type === addressType.BILL_TO ? (Object.keys(data.addressInfo).length === 0 ? t('addInvoiceAddress') : t('editInvoiceAddress')) : isWebUser ? (Object.keys(data.addressInfo).length === 0 ? t('addShippingAddress') : t('editShippingAddress')) : t('requestShippingAddress')}</h1>
        </div>
        <div className="modal-body">
          <form>
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="companyName" className="d-block">{t('companyName')}*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.companyName ? "error" : ""}`}
                  id="companyName"
                  placeholder={t('companyNamePH')}
                  name="companyName"
                  value={invoiceDetail.companyName}
                  maxLength={System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? 70 : 35}
                  onChange={({ target: { value } }) => onValueChange("companyName", value)}
                />
                {detailValidation.companyName && <p className="error">{detailValidation.companyName}</p>}
              </div>
            </div>
            {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="houseNumber" className="d-block">{t('houseNumber')}</label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${detailValidation.houseNumber ? "error" : ""}`}
                    id="houseNumber"
                    placeholder={t('houseNumber')}
                    name="houseNumber"
                    maxLength={6}
                    value={invoiceDetail.houseNum}
                    onChange={({ target: { value } }) => onValueChange("houseNum", value)}
                  />
                  {detailValidation.houseNumber && <p className="error">{detailValidation.houseNumber}</p>}
                </div>
              </div>
            }
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="addressLineOne" className="d-block">{t('address1')}*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.addressLineOne ? "error" : ""}`}
                  id="addressLineOne"
                  placeholder={t('address1PH')}
                  name="addressLineOne"
                  maxLength={35}
                  value={invoiceDetail.addressLineOne}
                  onChange={({ target: { value } }) => onValueChange("addressLineOne", value)}
                />
                {detailValidation.addressLineOne && <p className="error">{detailValidation.addressLineOne}</p>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label htmlFor="addressLineTwo" className="d-block">{t('address2')}</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.addressLineTwo ? "error" : ""}`}
                  id="addressLineTwo"
                  placeholder={t('address2PH')}
                  name="addressLineTwo"
                  maxLength={35}
                  value={invoiceDetail.addressLineTwo}
                  onChange={({ target: { value } }) => onValueChange("addressLineTwo", value)}
                />
                {detailValidation.addressLineTwo && <p className="error">{detailValidation.addressLineTwo}</p>}
              </div>
            </div>
            {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="addressLineThree" className="d-block">{t('address3')}</label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${detailValidation.addressLineThree ? "error" : ""}`}
                    id="addressLineThree"
                    placeholder={t('address3')}
                    name="addressLineThree"
                    maxLength={35}
                    value={invoiceDetail.addressLineThree}
                    onChange={({ target: { value } }) => onValueChange("addressLineThree", value)}
                  />
                  {detailValidation.addressLineThree && <p className="error">{detailValidation.addressLineThree}</p>}
                </div>
              </div>
            }
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="cityName" className="d-block">{t('city')}*</label>
                <input
                  type="text"
                  className={`form-control form-control-sm ${detailValidation.cityName ? "error" : ""}`}
                  id="cityName"
                  placeholder={t('cityPH')}
                  name="cityName"
                  maxLength={35}
                  value={invoiceDetail.cityName}
                  onChange={({ target: { value } }) => onValueChange("cityName", value)}
                />
                {detailValidation.cityName && <p className="error">{detailValidation.cityName}</p>}
              </div>
            </div>
            {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="district" className="d-block">{t('district')}</label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${detailValidation.district ? "error" : ""}`}
                    id="districtName"
                    placeholder={t('district')}
                    name="district"
                    maxLength={35}
                    value={invoiceDetail.district}
                    onChange={({ target: { value } }) => onValueChange("district", value)}
                  />
                  {detailValidation.district && <p className="error">{detailValidation.district}</p>}
                </div>
              </div>
            }
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="countryCode" className="d-block">{t('country')}*</label>
                <div className='selectbox'>
                  <select
                    className={`form-control form-control-sm ${detailValidation.countryCode ? "error" : ""}`}
                    name="countryCode"
                    value={invoiceDetail.countryCode}
                    disabled={System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr)}
                    onChange={
                      ({ target: { value } }) => {
                        onValueChange("countryCode", value);
                        setStateList([]);
                        setInvoiceDetail({ ...invoiceDetail, countryCode: value, stateCode: '', countryName: countryList?.find(ele => ele.countryCode === value)?.countryName, isUpdateCarrier: true });
                        if (countryCodes.includes(value)) {
                          renderStateListOnCountryChange(value)
                        }
                      }
                    }
                  >
                    <option value="" >- {t('pleaseSelect')} -</option>
                    {countryList?.map((v, i) => (
                      <option key={v.countryId} value={v.countryCode}>{v.countryName}</option>
                    ))}
                  </select>
                </div>
                {detailValidation.countryCode && <p className="error">{detailValidation.countryCode}</p>}
              </div>
            </div>

            <div className="bs5 row">
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="stateCode" className="d-block">{stateList.length !== 0 ? t('stateProvince') + '*' : t('stateProvince')}</label>
                  {(stateList.length !== 0) ?
                    <>
                      <div className='selectbox'>
                        <select
                          className={`form-control form-control-sm ${detailValidation.stateCode ? "error" : ""}`}
                          name="stateCode"
                          value={invoiceDetail.stateCode}
                          onChange={({ target: { value } }) => {
                            onValueChange("stateCode", value);
                            setInvoiceDetail({ ...invoiceDetail, stateCode: value, stateName: stateList?.find(ele => ele.stateCode === value)?.stateName });
                          }}
                        >
                          <option value="">- {t('pleaseSelect')} -</option>
                          {stateList.map((v, i) => (
                            <option key={v.stateId} value={v.stateCode}>{v.stateName}</option>
                          ))}
                        </select>
                      </div>
                      {detailValidation.stateCode && <p className="error">{detailValidation.stateCode}</p>}
                    </>
                    :
                    <>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${""}`}
                        id="stateCode"
                        placeholder={t('stateProvince')}
                        name="stateCode"
                        maxLength={60}
                        value={invoiceDetail.stateCode}
                        onChange={({ target: { value } }) => {
                          onValueChange("stateCode", value);
                          setInvoiceDetail({ ...invoiceDetail, stateCode: value, stateName: value });
                        }}
                      />
                      {detailValidation.stateCode && <p className="error">{detailValidation.stateCode}</p>}
                    </>
                  }
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="postalCode" className="d-block">{t('zipPostalCode')}*</label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${detailValidation.postalCode ? "error" : ""}`}
                    id="postalCode"
                    placeholder={t('zipPostalCode')}
                    maxLength={System.getZipCodeLength(invoiceDetail?.countryCode)}
                    name="postalCode"
                    value={invoiceDetail.postalCode}
                    onChange={({ target: { value } }) => onValueChange("postalCode", value)}
                  />
                  {detailValidation.postalCode && <p className="error">{detailValidation.postalCode}</p>}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer d-flex justify-content-center">
          <button type="button" className="bs5 btn btn-secondary minw140" disabled={__check(['SET_INVOICE_ADDRESS']).status} onClick={() => { SetStatus(false) }}>{t('cancel')}</button>
          <button type="button" className="bs5 btn btn-primary minw140" onClick={onSaveUser}>{__check(['SET_INVOICE_ADDRESS']).status ? <i className="fa fa-spinner fa-spin" /> : <>{t('submit')}</>}</button>
        </div>
      </div>
    </div>
  );
};

export default ProfileAddressPopup;
